module.exports = __webpack_public_path__ + "img/gc2.6dc67242.png";